import React, { useEffect, useState } from "react";
import Header from "./Header";
import Loader from "./Loader";

const Durabilite = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Delay the visibility of the component
    const timer = setTimeout(() => {
      setIsVisible(true); // Set to visible after the delay
    }, 200);

    return () => clearTimeout(timer); // Clean up on unmount
  }, []);
  return (
    <div>
      <div>
        <Header />
      </div>
      <Loader isVisible={isVisible} />
      <div>
        <section
          className="page-title bg-overlay-black-60 parallax"
          data-jarallax='{"speed": 0.6}'
          style={{
            backgroundImage: "url(/assets/images/Entreprise/RSE.png)",
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="page-title-name" style={{ width: "80%" }}>
                  <h1>Construire un avenir durable</h1>
                  <p>
                    SACEM Industries s'engage à intégrer les valeurs
                    environnementales, sociales et de gouvernance au cœur de sa
                    stratégie industrielle, pour un développement responsable au
                    service de ses collaborateurs, clients et de la communauté.
                  </p>
                </div>
                <ul className="page-breadcrumb">
                  <li>
                    <a href="/">
                      <i className="fa fa-home" /> Accueil
                    </a>{" "}
                    <i className="fa fa-angle-double-right" />
                  </li>
                  <li>
                    <span>R S E</span>{" "}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="page-section-ptb">
          <section
            className="action-box theme-bg full-width "
            style={{
              background: "#FFFFFF",
            }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-4 col-md-4">
                  <img
                    className="img-fluid full-width mb-20"
                    src="/assets/images/RSE/PacteMondiale.jpg"
                    alt="Responsabilité Sociétale SACEM"
                  />
                </div>
                <div className="col-lg-4 col-md-4">
                  {/**col-lg-6 col-md- */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                    }}
                  >
                    <p
                      style={{
                        color: "#9CA2AC",
                        textAlign: "center",
                      }}
                    >
                      Engagement actif en faveur des Dix Principes dans les
                      domaines des droits humains, du travail, de
                      l'environnement et de la lutte contre la corruption.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                    }}
                  >
                    <p
                      style={{
                        color: "#9CA2AC",
                        textAlign: "end",
                        fontSize: "12px",
                      }}
                    >
                      Période de reporting : Janvier – Décembre 2025
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div className="container">
              <div className="row">
                <div className="col-md-8">
                  <div className="section-title">
                    <h2 className="title-effect">
                      Déclaration du Directeur Général
                    </h2>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <div
                    className="owl-carousel"
                    data-nav-arrow="false"
                    data-nav-dots="true"
                    data-items={1}
                    data-lg-items={1}
                    data-md-items={1}
                    data-sm-items={1}
                    data-xs-items={1}
                  >
                    <div className="item">
                      <div className="testimonial bottom_pos light">
                        <div className="testimonial-info">
                          {" "}
                          <h3
                            style={{
                              fontSize: "18px",
                              lineHeight: "20px",
                              color: "#656565",
                            }}
                          >
                            Nous réaffirmons notre soutien aux Dix Principes du
                            Pacte Mondial des Nations Unies et notre ambition de
                            faire de SACEM Industries un acteur industriel
                            responsable et exemplaire.
                          </h3>
                          Notre démarche RSE n'est pas un exercice de
                          conformité, c'est une conviction profonde que la
                          performance industrielle et la responsabilité
                          environnementale et sociale sont indissociables.
                          Chaque transformateur que nous fabriquons à Tinja est
                          le reflet de cet engagement collectif.
                        </div>
                        <br />
                        <div>
                          {" "}
                          <strong>
                            Khaled Kammoun <br />{" "}
                            <span style={{ color: "#002f6c" }}>
                              Directeur Général — SACEM Industries
                            </span>
                          </strong>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 row">
                  <div className="col-lg-6 col-md-6">
                    <div className="mb-30 clearfix" style={{ padding: "20px" }}>
                      <div className="clients-info sm-pt-20">
                        <h5
                          style={{
                            fontFamily: "'Playfair Display', serif",
                            color: "#C8A96E",
                            fontSize: "38px",
                          }}
                        >
                          0%
                        </h5>

                        <p>Écart de rémunération femmes / hommes</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="mb-30 clearfix" style={{ padding: "20px" }}>
                      <div className="clients-info sm-pt-20">
                        <h5
                          style={{
                            fontFamily: "'Playfair Display', serif",
                            color: "#C8A96E",
                            fontSize: "38px",
                          }}
                        >
                          30%
                        </h5>

                        <p>Femmes aux postes de direction.</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 sm-mb-30">
                    <div className=" clearfix" style={{ padding: "20px" }}>
                      <div className="clients-info sm-pt-20">
                        <h5
                          style={{
                            fontFamily: "'Playfair Display', serif",
                            color: "#C8A96E",
                            fontSize: "38px",
                          }}
                        >
                          3091
                        </h5>

                        <p>m³ d'eau consommée en 2025</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className=" clearfix" style={{ padding: "20px" }}>
                      <div className="clients-info sm-pt-20">
                        <h5
                          style={{
                            fontFamily: "'Playfair Display', serif",
                            color: "#C8A96E",
                            fontSize: "38px",
                          }}
                        >
                          1.75
                        </h5>

                        <p>Taux d'accidents du travail (‰)</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="container">
            <div className="row ">
              <div className="col-lg-12 col-md-12">
                <h3 className="mb-30">Nos Trois Piliers</h3>
                <h5 className="mb-30">
                  Une approche RSE structurée et ambitieuse
                </h5>
                <p>
                  Notre stratégie de développement durable s'articule autour de
                  trois axes fondamentaux, guidés par les principes du Pacte
                  Mondial de l'ONU et alignés sur les Objectifs de Développement
                  Durable.
                </p>
              </div>
              <div className="col-lg-4 col-md-4 sm-mb-30">
                <div className="card" style={{ height: "100%" }}>
                  <div
                    className="card-body"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        width: "56px",
                        height: "56px",
                        display: "flex",
                        borderRadius: "12px",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "26px",
                        lineHeight: "1",
                        marginBottom: "20px",
                      }}
                    >
                      🌱
                    </div>
                    <div style={{ width: "100%" }}>
                      <h6 className="card-subtitle mb-2 text-muted mb-30">
                        Pilier 1
                      </h6>
                      <h5 className="card-title mb-30">Environnement</h5>

                      <p className="card-text" style={{ fontSize: "14px" }}>
                        Réduire notre impact environnemental à travers une
                        gestion rigoureuse des ressources, des déchets et de
                        l'énergie dans notre site industriel de Tinja.
                      </p>
                      <div style={{ fontSize: "12px" }}>
                        <ul className="list list list-unstyled mb-30">
                          <li>
                            {" "}
                            <i className="fa fa-dot-circle-o" />
                            Optimisation de la gestion des déchets industriels
                          </li>
                          <li>
                            {" "}
                            <i className="fa fa-dot-circle-o" />
                            Réduction de la consommation d'eau (objectif : –15
                            %)
                          </li>
                          <li>
                            {" "}
                            <i className="fa fa-dot-circle-o" />
                            Transition vers les énergies renouvelables
                          </li>
                          <li>
                            {" "}
                            <i className="fa fa-dot-circle-o" />
                            Mesure des émissions GES prévue fin 2026
                          </li>
                          <li>
                            {" "}
                            <i className="fa fa-dot-circle-o" />
                            Réduction des fuites d'huile des transformateurs
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 sm-mb-30">
                <div className="card" style={{ height: "100%" }}>
                  <div
                    className="card-body"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        width: "56px",
                        height: "56px",
                        display: "flex",
                        borderRadius: "12px",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "26px",
                        lineHeight: "1",
                        marginBottom: "20px",
                      }}
                    >
                      🤝
                    </div>
                    <div style={{ width: "100%" }}>
                      <h6 className="card-subtitle mb-2 text-muted mb-30">
                        Pilier 2
                      </h6>
                      <h5 className="card-title mb-30">Social</h5>

                      <p className="card-text" style={{ fontSize: "14px" }}>
                        Valoriser nos collaborateurs et contribuer au
                        développement de la communauté locale de Tinja, en
                        Tunisie et à l'international.
                      </p>
                      <div style={{ fontSize: "12px" }}>
                        <ul className="list list list-unstyled mb-30">
                          <li>
                            {" "}
                            <i className="fa fa-dot-circle-o" />0 % d'écart
                            salarial femmes / hommes
                          </li>
                          <li>
                            {" "}
                            <i className="fa fa-dot-circle-o" />
                            30 % de femmes aux postes de direction
                          </li>
                          <li>
                            {" "}
                            <i className="fa fa-dot-circle-o" />
                            Réhabilitation du dispensaire de Tinja
                          </li>
                          <li>
                            {" "}
                            <i className="fa fa-dot-circle-o" />
                            Renforcement de la culture sécurité (HSE)
                          </li>
                          <li>
                            {" "}
                            <i className="fa fa-dot-circle-o" />
                            Processus formels d'alerte et de protection
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 sm-mb-30">
                <div className="card" style={{ height: "100%" }}>
                  <div
                    className="card-body"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        width: "56px",
                        height: "56px",
                        display: "flex",
                        borderRadius: "12px",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "26px",
                        lineHeight: "1",
                        marginBottom: "20px",
                      }}
                    >
                      ⚖️
                    </div>
                    <div style={{ width: "100%" }}>
                      <h6 className="card-subtitle mb-2 text-muted mb-30">
                        Pilier 3
                      </h6>
                      <h5 className="card-title mb-30">Gouvernance</h5>

                      <p className="card-text" style={{ fontSize: "14px" }}>
                        Assurer une gouvernance éthique et transparente, avec
                        des mécanismes robustes d'intégrité, de conformité et de
                        lutte contre la corruption.
                      </p>
                      <div style={{ fontSize: "12px" }}>
                        <ul className="list list list-unstyled mb-30">
                          <li>
                            {" "}
                            <i className="fa fa-dot-circle-o" />
                            Code de conduite sur toute la chaîne de valeur
                          </li>
                          <li>
                            {" "}
                            <i className="fa fa-dot-circle-o" />
                            Programme de conformité anti-corruption
                          </li>
                          <li>
                            {" "}
                            <i className="fa fa-dot-circle-o" />
                            Formation annuelle du Directeur Juridique et DRH
                          </li>
                          <li>
                            {" "}
                            <i className="fa fa-dot-circle-o" />
                            Conseil d'administration : 7 membres, 30 % de femmes
                          </li>
                          <li>
                            {" "}
                            <i className="fa fa-dot-circle-o" />
                            Canaux confidentiels de signalement interne
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="container" style={{paddingTop:"30px"}}>
            <div className="row">
            <div className="col-lg-12 col-md-12">
            <h5 className="mb-30" style={{
                            fontFamily: "'Playfair Display', serif",
                            color: "#C8A96E",
                          }}>Initiatives 2025</h5>
            <h3 className="mb-30" style={{
                            fontFamily: "'Playfair Display', serif",
                            color: "#C8A96E",
                          }}>Actions concrètes et réalisations</h3>
            </div>
            </div>
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <div className="clients-box mb-30 clearfix">
                  <div className="clients-photo">
                    <img src="images/clients/03.png" alt />
                  </div>
                  <div className="clients-info sm-pt-20">
                  <h6 style={{fontSize:"10px"}}> Communauté locale</h6>
                    <h5>Réhabilitation du Dispensaire de Tinja</h5>
                    
                    <p>
                      SACEM Industries a financé et coordonné la remise à niveau complète du dispensaire de Tinja, améliorant les conditions d'accueil des patients et l'environnement de travail du personnel médical. Un projet à forte valeur humaine qui renforce l'ancrage territorial de l'entreprise.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="clients-box mb-30 clearfix">
                  <div className="clients-photo">
                    <img src="images/clients/04.png" alt />
                  </div>
                  <div className="clients-info sm-pt-20">
                     <h6 style={{fontSize:"10px"}}>  Environnement</h6>
                    <h5>Plan de réduction de la consommation d'eau</h5>
                    
                    <p>
                      Mise en place d'un suivi régulier de la consommation d'eau (3 091 m³ en 2025) avec un objectif de réduction progressive. Les progrès sont communiqués en interne au plus haut niveau de l'entreprise et intégrés à notre stratégie opérationnelle.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="clients-box mb-30 clearfix">
                  <div className="clients-photo">
                    <img src="images/clients/05.png" alt />
                  </div>
                  <div className="clients-info sm-pt-20">
                     <h6 style={{fontSize:"10px"}}>  Énergie</h6>
                    <h5>Stratégie de transition énergétique</h5>
                    
                    <p>
                      Engagement vers l'adoption des énergies renouvelables et l'optimisation de l'empreinte énergétique de nos processus de production. Un plan de transition sera soumis à la Direction Générale pour validation formelle.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6">
                <div className="clients-box mb-30 clearfix">
                  <div className="clients-photo">
                    <img src="images/clients/02.png" alt />
                  </div>
                  <div className="clients-info sm-pt-20">
                      <h6 style={{fontSize:"10px"}}>Sécurité au travail</h6>
                    <h5>Renforcement de la culture HSE</h5>
                    
                    <p>
                     Poursuite du programme de prévention des risques industriels avec des formations régulières et un suivi des objectifs annuels. Taux d'accidents du travail : 1,75 ‰ — avec un objectif de réduction continue pour les deux prochaines années.
                    </p>
                  </div>
                </div>
              </div>
       
            </div>
          </section>
        </section>
      </div>
    </div>
  );
};

export default Durabilite;
